/* @flow strict */

import * as React from 'react';
import DataTable from 'react-data-table-component';
import { columns } from './tableHeaders/db';
import TableSkeleton from '/client/src/components/skeletons/dataTableSkeleton';

type PropsType = {
  data: [],
  progressPending: boolean,
  maxResultCount: number,
  setMaxResultCount: (number) => void,
  totalRows: number,
  handlePageChange: (number) => void,
  handleSort: (string) => void,
  currentPage: number
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  }
};

let mock = {
  columns: []
};

const DBBody = ({
  data,
  progressPending,
  maxResultCount,
  currentPage,
  totalRows,
  handleSort,
  setMaxResultCount,
  handlePageChange
}: PropsType): React.Element<'div'> => {
  try {
    mock = require('./tableHeaders/db.js');
  } catch (e) {
    console.warn('File "./tableHeaders/db.js" doesn\'t exist');
  }
  return (
    <div className="panel-body">
      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <DataTable
            columns={columns}
            data={data}
            customStyles={customStyles}
            sortServer
            onSort={(column, sortDirection): void => handleSort(`${column.selector}+${sortDirection}`)}
            highlightOnHover
            pointerOnHover
            responsive
            striped
            fixedHeader
            noHeader
            pagination
            paginationPerPage={maxResultCount}
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationRowsPerPageOptions={[100, 500, 1000]}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={setMaxResultCount}
            persistTableHead
            progressPending={progressPending}
            progressComponent={<TableSkeleton rows={maxResultCount} columns={columns} />}
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DBBody;
